/**
 * Friendly replies to messages that have nothing to do with Noticeboard. Each one ends by
 * pointing back to something Ask Noticeboard can do, using only pages every Team role can open.
 */
export const OFF_TOPIC_REPLIES = [
  "I'd love to help with that, but I only know about Noticeboard. Try asking me to find a page, like Calendar or Drive.",
  "That's a good question, but not one I can answer! I'm best at Noticeboard. Ask me where to find your Notices.",
  "I'm afraid I can't help with that. I can help you find your way around Noticeboard, though. Try typing a page name.",
  "Great question, but I only help with Noticeboard. Ask me where to send a Notice.",
  "I wish I knew! I stick to Noticeboard. Try asking me where to change your profile.",
  "That one's beyond me. I'm here for Noticeboard things, like finding the Calendar or your Account.",
  "Sounds interesting! I can only help with Noticeboard, though. Ask me where the Help Center is.",
  "I'll have to pass on that one. I'm much better at Noticeboard. Try \"Where can I see my Notices?\"",
  "That's not something I can help with, sorry. I can take you to any page in your sidebar. Just type its name.",
  "Good thinking, but I only know my way around Noticeboard. Ask me where to find your files in Drive.",
  "I'm not the right helper for that. I know Noticeboard inside out, though. Try asking where to start a Notice.",
  "I'd only be guessing there, and I don't like to guess. Ask me about Noticeboard instead, like where to watch a tutorial.",
];

/** The off-topic reply for this turn; goes through every reply before repeating one. */
export function offTopicReply(turn: number): string {
  return OFF_TOPIC_REPLIES[turn % OFF_TOPIC_REPLIES.length];
}
